export default "__VITE_ASSET__579a1175__"